import DataEntry from './components/DataEntry';
import {Switch} from "react-router-dom";
import ErrorBoundaryRoute from "../../../../containers/ErrorBoundaryRoute";
import React from "react";

export default ({match, regions, roles, user, main_role}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<DataEntry user={user}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);